import * as Lucide from 'lucide-react';

interface IconProps {
  name: string;
  className?: string;
}

export default function Icon({ name, className }: IconProps) {
  const LucideIcon = (Lucide as any)[name] || Lucide.Circle;
  return <LucideIcon className={className} />;
}
